import type { RouteObject } from "react-router-dom";

export const emailSuppressionRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Email suppression check" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { EmailSuppressionPage } =
            await import("./email-suppression-page");
          return { Component: EmailSuppressionPage };
        },
      },
    ],
  },
];
